import { jsx as _jsx } from "react/jsx-runtime";
import RadioGroupControlled from "./RadioGroupControlled.js";
import RadioGroupUncontrolled from "./RadioGroupUncontrolled.js";
const RadioGroup = (props) => {
    const { value } = props;
    if (value !== undefined)
        return _jsx(RadioGroupControlled, { ...props });
    return _jsx(RadioGroupUncontrolled, { ...props });
};
RadioGroup.displayName = "RadioGroup";
export default RadioGroup;
